export const states = [
    {
        name: 'Alabama',
        abbreviation: 'AL',
    },
    {
        name: 'Alaska',
        abbreviation: 'AK',
    },
    {
        name: 'Arizona',
        abbreviation: 'AZ',
    },
    {
        name: 'Arkansas',
        abbreviation: 'AR',
    },
    {
        name: 'California',
        abbreviation: 'CA',
    },
    {
        name: 'Colorado',
        abbreviation: 'CO',
    },
    {
        name: 'Connecticut',
        abbreviation: 'CT',
    },
    {
        name: 'Delaware',
        abbreviation: 'DE',
    },
    {
        name: 'Florida',
        abbreviation: 'FL',
    },
    {
        name: 'Georgia',
        abbreviation: 'GA',
    },
    {
        name: 'Hawaii',
        abbreviation: 'HI',
    },
    {
        name: 'Idaho',
        abbreviation: 'ID',
    },
    {
        name: 'Illinois',
        abbreviation: 'IL',
    },
    {
        name: 'Indiana',
        abbreviation: 'IN',
    },
    {
        name: 'Iowa',
        abbreviation: 'IA',
    },
    {
        name: 'Kansas',
        abbreviation: 'KS',
    },
    {
        name: 'Kentucky',
        abbreviation: 'KY',
    },
    {
        name: 'Louisiana',
        abbreviation: 'LA',
    },
    {
        name: 'Maine',
        abbreviation: 'ME',
    },
    {
        name: 'Maryland',
        abbreviation: 'MD',
    },
    {
        name: 'Massachusetts',
        abbreviation: 'MA',
    },
    {
        name: 'Michigan',
        abbreviation: 'MI',
    },
    {
        name: 'Minnesota',
        abbreviation: 'MN',
    },
    {
        name: 'Mississippi',
        abbreviation: 'MS',
    },
    {
        name: 'Missouri',
        abbreviation: 'MO',
    },
    {
        name: 'Montana',
        abbreviation: 'MT',
    },
    {
        name: 'Nebraska',
        abbreviation: 'NE',
    },
    {
        name: 'Nevada',
        abbreviation: 'NV',
    },
    {
        name: 'New Hampshire',
        abbreviation: 'NH',
    },
    {
        name: 'New Jersey',
        abbreviation: 'NJ',
    },
    {
        name: 'New Mexico',
        abbreviation: 'NM',
    },
    {
        name: 'New York',
        abbreviation: 'NY',
    },
    {
        name: 'North Carolina',
        abbreviation: 'NC',
    },
    {
        name: 'North Dakota',
        abbreviation: 'ND',
    },
    {
        name: 'Ohio',
        abbreviation: 'OH',
    },
    {
        name: 'Oklahoma',
        abbreviation: 'OK',
    },
    {
        name: 'Oregon',
        abbreviation: 'OR',
    },
    {
        name: 'Pennsylvania',
        abbreviation: 'PA',
    },
    {
        name: 'Rhode Island',
        abbreviation: 'RI',
    },
    {
        name: 'South Carolina',
        abbreviation: 'SC',
    },
    {
        name: 'South Dakota',
        abbreviation: 'SD',
    },
    {
        name: 'Tennessee',
        abbreviation: 'TN',
    },
    {
        name: 'Texas',
        abbreviation: 'TX',
    },
    {
        name: 'Utah',
        abbreviation: 'UT',
    },
    {
        name: 'Vermont',
        abbreviation: 'VT',
    },
    {
        name: 'Virginia',
        abbreviation: 'VA',
    },
    {
        name: 'Washington',
        abbreviation: 'WA',
    },
    {
        name: 'West Virginia',
        abbreviation: 'WV',
    },
    {
        name: 'Wisconsin',
        abbreviation: 'WI',
    },
    {
        name: 'Wyoming',
        abbreviation: 'WY',
    },
    {
        name: 'District of Columbia',
        abbreviation: 'DC',
    },
    {
        name: 'Puerto Rico',
        abbreviation: 'PR',
    },
    {
        name: 'Guam',
        abbreviation: 'GU',
    },
    {
        name: 'American Samoa',
        abbreviation: 'AS',
    },
    {
        name: 'U.S. Virgin Islands',
        abbreviation: 'VI',
    },
    {
        name: 'Northern Mariana Islands',
        abbreviation: 'MP',
    },
];

export const categoriesOptions = [
    { category: 'Medical', name: 'Medical' },
    { category: 'Dental', name: 'Dental' },
    { category: 'Vision', name: 'Vision' },
    { category: 'Mental Health', name: 'Mental Health' },
    { category: 'Chiropractic', name: 'Chiropractic' },
    { category: 'Physical therapy', name: 'Physical therapy' },
    { category: 'Health & Wellness', name: 'Health & Wellness' },
    { category: 'Labs & Radiology', name: 'Labs & Radiology' },
    { category: 'Others', name: 'Others' },
];

export const categorySpecialties = {
    Medical: [
        'Addictive Medicine',
        'Adolescent Medicine',
        'Allergy and Immunology',
        'Anesthesiologic Emergency Care',
        'Anesthesiology & Pain Management',
        'Cardiology',
        'Critical Care Medicine',
        'Dermatology',
        'Dermatopathology',
        'Emergency Services',
        'Endocrinology',
        'Family Medicine',
        'Gastrointestinal',
        'Geriatric Medicine',
        'Gynelogic Care',
        'Hematology',
        'Hospice and Palliative Care',
        'Internal Medicine',
        'Medical Toxicology',
        'Naturopathic Medicine',
        'Neurology',
        'OBGYN',
        'Oncology',
        'Pain Medicine',
        'Pediatric Anesthesiology',
        'Pediatric Dermatology',
        'Pediatric Emergency Medicine',
        'Pregnancy Care',
        'Primary Health Care for Women',
        'Procedural Dermatology',
        'Psychiatry',
        'Pulmonology',
        'Sleep Medicine',
        'Sports Medicine',
        'Urgent Care',
    ],
    Dental: [
        'Endodontics',
        'General Dentistry',
        'Oral Surgery',
        'Orthodontics',
        'Pediatric Dentistry',
        'Periodontics',
        'Prosthodontics',
    ],
    Vision: [
        'Optometry',
        'Ophthalmology',
        'Pediatric Ophthalmology',
        'Neuro-Ophthalmology',
        'Ocular Oncology',
        'Strabismus',
        'Diabetic Retinopathy',
        'Cataracts',
    ],
    'Mental Health': ['Counseling', 'Psychiatry'],
    Chiropractic: ['Symptom Relief Chiropractic', 'Traditional Wellness Chiropractic'],
    'Physical therapy': [
        'Cardiovascular and Pulmonary',
        'Clinical Electrophysiology',
        'Geriatrics',
        'Neurology',
        'Oncology',
        'Orthopedics',
        'Pediatrics',
        'Sports',
        "Women's Health",
    ],
    'Health & Wellness': ['Longevity Medicine', 'Naturopathic Medicine'],
    'Labs & Radiology': [
        'Abdominal Radiology',
        'Breast Imaging',
        'Cardiothoracic Radiology',
        'Cardiovascular Radiology',
        'Chest Radiology',
        'Emergency Radiology',
        'Endovascular Surgical Neuroradiology',
        'Gastrointestinal Radiology',
        'Genitourinary Radiology',
        'Head and Neck Radiology',
        'Interventional Radiology',
        'Musculoskeletal Radiology',
        'Neuroradiology',
        'Nuclear Radiology',
        'Pathology',
        'Pediatric Radiology',
        'Radiation Oncology',
        'Vascular and Interventional Radiology',
    ],
};
